import React, { useContext } from 'react';

import { createStyles, Theme, makeStyles } from '@material-ui/core/styles';
import { Grid, Typography } from '@material-ui/core';
import { observer } from 'mobx-react-lite';
import { StandardTypography } from '../common/typography';
import { StoreContext } from '../../mobx/RootStore';

const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		mainContainer: {
			background: 'linear-gradient(1.94deg, #81D5F2 -6.55%, #00ADEE 52.45%);',
			marginBottom: '-20px',
			marginTop: '-20px',
			paddingBottom: theme.spacing(24),
			paddingTop: theme.spacing(24),
		},
		whyContainer: {
			height: '100%',
		},
		rollImage: {
			width: '586px',
			[theme.breakpoints.down('lg')]: {
				width: '460px',
			},
			[theme.breakpoints.down('md')]: {
				width: '280px',
				paddingTop: theme.spacing(4),
				paddingBottom: theme.spacing(8),
				marginLeft: 'auto',
				marginRight: 'auto',
			},
		},
		responsiveH2Text: {
			paddingBottom: theme.spacing(6),
			[theme.breakpoints.down('lg')]: {
				fontSize: '3rem',
			},
			[theme.breakpoints.down('md')]: {
				fontSize: '2rem',
				paddingBottom: theme.spacing(4),
			},
		},
		responsiveH3Text: {
			paddingBottom: theme.spacing(1),
			[theme.breakpoints.down('md')]: {
				fontSize: '1.5rem',
			},
		},
		responsiveH5Text: {
			paddingBottom: theme.spacing(6),
			[theme.breakpoints.down('md')]: {
				fontSize: '1rem',
				paddingBottom: theme.spacing(4),
			},
		},
		rollContainer: {
			marginTop: 'auto',
			marginBottom: 'auto',
			textAlign: 'center',
		},
	}),
);

export const Why = observer(() => {
	const classes = useStyles();
	const store = useContext(StoreContext);
	const {
		uiState: { desktopView },
	} = store;
	return (
		<Grid className={classes.mainContainer} container direction="row" justifyContent="space-evenly">
			{desktopView ? (
				<Grid className={classes.rollContainer} item lg={4} xs={12}>
					<img alt="NFTP Roll" className={classes.rollImage} src="rolls/roll154.png" />
				</Grid>
			) : null}
			<Grid item lg={5} xs={8}>
				<Grid className={classes.whyContainer} container direction="column" justifyContent="space-evenly">
					<Typography className={classes.responsiveH2Text} variant="h2" color="textSecondary">
						Wiping Never Felt So Good
					</Typography>
					{desktopView ? null : <img alt="NFTP Roll" className={classes.rollImage} src="rolls/roll154.png" />}
					<Typography className={classes.responsiveH3Text} variant="h4" color="textPrimary">
						Show Off
					</Typography>
					<StandardTypography className={classes.responsiveH5Text} variant="h5" color="textSecondary">
						Rainbow Rolls are more than just a fun collectible, they’re a badge to show you give a shit
						about making the world a better place.
					</StandardTypography>
					<Typography className={classes.responsiveH3Text} variant="h4" color="textPrimary">
						Make an Impact
					</Typography>
					<StandardTypography className={classes.responsiveH5Text} variant="h5" color="textSecondary">
						69% of funds raised go directly to funding public and social goods organizations like Giveth,
						Gitcoin, RIP Medical Debt, and more.
					</StandardTypography>
					<Typography className={classes.responsiveH3Text} variant="h4" color="textPrimary">
						Influence Future Donations
					</Typography>
					<StandardTypography className={classes.responsiveH5Text} variant="h5" color="textSecondary">
						Help reward those who are creating positive change in the world. As a Rainbow Roll holder,
						you’ll be able to vote on our Retroactive Public Goods Funding donations.
					</StandardTypography>
					<Typography className={classes.responsiveH3Text} variant="h4" color="textPrimary">
						Win Prizes Each Month
					</Typography>
					<StandardTypography className={classes.responsiveH5Text} variant="h5" color="textSecondary">
						Hold on to your Rainbow Roll to be part of our monthly drawing for a chance to win exclusive
						Rainbow Rolls NFTs, prizes, and more!
					</StandardTypography>
				</Grid>
			</Grid>
		</Grid>
	);
});

export default Why;
